import styled from 'styled-components';

export const StarsComponentContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StarContainer = styled.div`
  position: relative;
  width: 24px;
  height: 24px;

  svg {
    position: absolute;
    font-size: 24px;
    fill: ${({ theme }) => theme.colors.yellow.default};
  }
  svg.filled {
    clip-path: inset(
      0 calc(24px - ${({ percentage }) => 5 + percentage + 'px'}) 0 0
    );
  }
`;
